export default function PageLoader() {
  return (
    <div className="flex items-center justify-center min-h-[50vh]">
      <div className="w-8 h-8 border-4 border-gray-200 border-t-cs-blue rounded-full animate-spin"></div>
    </div>
  );
}